import { toast } from 'react-toastify';

export const useApiToast = () => {
  const showToast = (message, type) => {
    if (type === 'success') toast.success(message);
    else if (type === 'error') toast.error(message);
    else toast(message);
  };
  return { showToast };
};